import React from 'react';
import Icon from '../ui/Icon';
import './Streak.css';

const DAY_LABELS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

// `streak` is exactly playerProgressService's shape: { days, active_today,
// last_7_days: [{date, active}] }. A 0-day streak is shown plainly, never
// as a failure state — "come back and keep building," not "you failed."
const Streak = ({ streak, compact = false }) => {
  const { days, active_today: activeToday, last_7_days: last7 } = streak;

  if (compact) {
    return (
      <span className="z-streak z-streak--compact" aria-label={`${days} day streak`}>
        <Icon name="streak" size={16} className="z-streak-flame" />
        <span className="z-streak-count">{days}</span>
      </span>
    );
  }

  return (
    <div className="z-streak-card">
      <div className="z-streak-headline">
        <Icon name="streak" art size={40} className="z-streak-art" eager />
        <span className="z-streak-count">{days}</span>
        <span className="z-streak-unit">day{days === 1 ? '' : 's'}</span>
      </div>
      <p className="z-streak-message">
        {days === 0
          ? (activeToday ? 'Nice — you\'ve started today\'s streak.' : 'Come back and keep building.')
          : activeToday
            ? 'Streak active today — keep it going.'
            : 'Come back today to keep your streak alive.'}
      </p>
      <div className="z-streak-week" role="img" aria-label={`Activity over the last 7 days: ${last7.filter(d => d.active).length} active day(s)`}>
        {last7.map((d) => (
          <span key={d.date} className={`z-streak-day ${d.active ? 'z-streak-day--active' : ''}`}>
            <span className="z-streak-day-dot" />
            <span className="z-streak-day-label">{DAY_LABELS[new Date(d.date + 'T00:00:00Z').getUTCDay()]}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Streak;
